import { useState, useEffect } from "react";
import { useNavigate, useLoaderData } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { MuiFileInput } from "mui-file-input";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { getProductCategory } from "../../services/productCategory";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { createCoupon } from "../../services/coupon";
import { isSubscriptionRequiredError } from "../../services/subscription";
import { SubscriptionModal } from "../modal/SubscriptionModal";
import { toast, ToastContainer } from "react-toastify";
import { Carousel } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./ProductCoupon.css";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';

export const ProductCoupon = ({
  type,
  src,
  dataString,
  codeData,
  expiryDate,
  startDate,
  OfferDetails
}) => {
  const navigate = useNavigate();
  const data = JSON.parse(useLoaderData());

  const [productImage, setProductImage] = useState([]);
  const [uploadImage, setUploadImage] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [productData, setProductData] = useState({});
  const [imageError, setImageError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [shortDescError, setShortDescError] = useState(false);
  const [offerDescError, setOfferDescError] = useState(false);
  const [consumerError, setConsumerError] = useState(false);
  const [retailerError, setRetailerError] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

  useEffect(() => {
    if (data?.email === process.env.REACT_APP_ADMIN_EMAIL) {
      setIsAdmin(true);
      return;
    }
  }, []);

  // Cleanup body class on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove("subscription-modal-open");
    };
  }, []);

  const handleShowSubscriptionModal = () => {
    document.body.classList.add("subscription-modal-open");
    setShowSubscriptionModal(true);
  };

  const handleHideSubscriptionModal = () => {
    document.body.classList.remove("subscription-modal-open");
    setShowSubscriptionModal(false);
  };

  useEffect(() => {
    return async () => {
      setProductCategories([]);
      const data = await getProductCategory();
      data?.map((d) => [
        setProductCategories((data) => [
          ...data,
          { label: d.product_category_name, value: d.product_category_name },
        ]),
      ]);
    };
  }, []);

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      setProductImage((items) => [...items, reader.result]);
    };
  };

  const handleProductImage = (value) => {
    console.log("product image: ", value);

    setUploadImage(value);

    if (value.length === 0) {
      setProductImage([]);
      return;
    }

    value.map((image) => {
      convertToBase64(image);
    });

    // setProductImage(value);
    return;
  };

  const handleProductChange = (e) => {
    setProductData({ ...productData, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (e, rowValue, reason) => {
    if (reason === "selectOption") {
      setProductData({ ...productData, category: rowValue.value });
    } else {
      return;
    }
  };

  const consumerEditorChange = (e) => {
    setProductData({ ...productData, consumer: e });
    return;
  };

  const retailerEditorChange = (e) => {
    setProductData({ ...productData, retailer: e });
    return;
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();

    if (productImage.length === 0) {
      setImageError(true);
    } else {
      setImageError(false);
    }

    if (!productData.name) {
      setNameError(true);
    } else {
      setNameError(false);
    }

    if (!productData.category) {
      setCategoryError(true);
    } else {
      setCategoryError(false);
    }

    if (!productData.offerDesc) {
      setOfferDescError(true);
    } else {
      setOfferDescError(false);
    }

    if (!productData.shortDesc) {
      setShortDescError(true);
    } else {
      setShortDescError(false);
    }

    if (!productData.retailer) {
      setRetailerError(true);
    } else {
      setRetailerError(false);
    }

    if (!productData.consumer) {
      setConsumerError(true);
    } else {
      setConsumerError(false);
    }

    if (
      productImage.length === 0 ||
      !productData.name ||
      !productData.shortDesc ||
      !productData.category ||
      !productData.consumer ||
      !productData.retailer
    ) {
      return;
    }
    console.log("product data: ", productData);

    setLoading(true);

    try {
      const res = await createCoupon(
        data.email,
        dataString,
        type,
        src,
        productData.name,
        productData.category,
        ` ${productData.shortDesc}`,
        `LIMIT ONE COUPON PER VISIT | MANUFACTURER'S COUPON${
          startDate ? ` | START DATE ${startDate}` : ""
        }${expiryDate ? ` | EXPIRATION DATE ${expiryDate}` : ""}`,
        productData.consumer,
        productData.retailer,
        productData.footer ? productData.footer : null,
        expiryDate ? expiryDate : null,
        codeData.saveValue
          ? `$${codeData.saveValue.substring(
              0,
              1
            )}.${codeData.saveValue.substring(1)}`
          : null,
        productImage
      );

      if (res === null) {
        setLoading(false);
        toast.error("Unable to create coupon, please try later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }

      setLoading(false);
      toast.success("Coupon created successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate(-1);
      return;
    } catch (err) {
      setLoading(false);
      if (isSubscriptionRequiredError(err)) {
        handleShowSubscriptionModal();
        return;
      }
      toast.error("Unable to create coupon, please try later.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 145px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: '65px' }}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        containerId="notification"
      />

      {/* Header with back button, title and progress bar */}
      <Box sx={{ px: 3, pt: 1.5, pb: 1.5, bgcolor: 'white', zIndex: 10, position: 'sticky', top: 0 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 0.5, minHeight: '32px' }}>
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{
                mr: 1,
                p: 0.5,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                alignSelf: 'center'
              }}
            >
              <ChevronLeftIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontSize: '1.1rem', color: 'black', lineHeight: 1 }}>
              Design Coupon
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mb: 1.5, fontSize: '0.8rem', color: 'black', ml: '40px' }}>
            Preview and Finalize Coupon
          </Typography>
        </Box>

        {/* Progress Bar - 4 steps all filled */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          {[1, 2, 3, 4].map((step) => (
            <Box
              key={step}
              sx={{
                flex: 1,
                height: 8,
                bgcolor: '#1976d2',
                borderRadius: 2,
                transition: 'background-color 0.3s ease'
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1, overflow: 'auto', px: 3, pb: 3, pt: 3 }}>
        <Box component="form" onSubmit={handleProductSubmit}>
          {/* Product & Offer Details Section */}
          <Paper elevation={0} sx={{ p: 0, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }}>
              Product & Offer Details
            </Typography>

              {/* Image Upload Section */}
              <Box sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 3,
                p: 3,
                mb: 1.5,
                textAlign: 'center',
                minHeight: 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {productImage.length > 0 ? (
                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    {productImage.map((item, key) => (
                      <img
                        key={key}
                        className="productImage"
                        src={item}
                        alt="product-image"
                        loading="lazy"
                        style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'contain' }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Box sx={{
                    width: 80,
                    height: 80,
                    bgcolor: '#e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    <AddPhotoAlternateIcon sx={{ fontSize: 40, color: '#9e9e9e' }} />
                  </Box>
                )}
                <Button
                  component="label"
                  variant="text"
                  sx={{ textTransform: 'none', color: '#1976d2', fontSize: '0.9rem', fontWeight: 500 }}
                >
                  Browse Image
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="image/*"
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      setUploadImage(files);
                      files.forEach(file => convertToBase64(file));
                    }}
                  />
                </Button>
                {imageError && (
                  <Typography variant="caption" color="error" sx={{ mt: 1, fontSize: '0.7rem' }}>
                    Please upload at least one product image
                  </Typography>
                )}
              </Box>

              {/* Product Name */}
              <TextField
                name="name"
                type="text"
                label="Product Name"
                variant="outlined"
                fullWidth
                size="small"
                value={productData.name || ""}
                onChange={handleProductChange}
                error={nameError}
                helperText={nameError && "Please enter product name"}
                sx={{
                  mb: 1.5,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '25px',
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '0.7rem',
                  }
                }}
              />

              {/* Product Category */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                <Autocomplete
                  disablePortal
                  options={productCategories}
                  name="category"
                  onChange={handleCategoryChange}
                  autoSelect={true}
                  loading={productCategories.length === 0}
                  sx={{ flex: 1 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Product Category"
                      size="small"
                      error={categoryError}
                      helperText={categoryError && "Please select a product category"}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '25px',
                        },
                        '& .MuiFormHelperText-root': {
                          fontSize: '0.7rem',
                        }
                      }}
                    />
                  )}
                />
                {isAdmin && (
                  <Tooltip title="Add product category">
                    <IconButton
                      onClick={() => navigate("/productcategory/login")}
                      size="small"
                      sx={{
                        border: '1px solid #1976d2',
                        borderRadius: '50%',
                        color: '#1976d2',
                        width: 36,
                        height: 36,
                        flexShrink: 0
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>

              {/* Offer Details */}
              <TextField
                name="offerDesc"
                type="text"
                label="Offer Details"
                variant="outlined"
                fullWidth
                size="small"
                value={productData.offerDesc || ""}
                onChange={handleProductChange}
                error={offerDescError}
                helperText={offerDescError && "Please enter offer details"}
                sx={{
                  mb: 1.5,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '25px',
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '0.7rem',
                  }
                }}
              />

              {/* Short Description */}
              <TextField
                name="shortDesc"
                type="text"
                label="Short Description"
                variant="outlined"
                fullWidth
                size="small"
                value={productData.shortDesc || ""}
                onChange={handleProductChange}
                error={shortDescError}
                helperText={shortDescError && "Please enter short description"}
                sx={{
                  mb: 1.5,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '25px',
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '0.7rem',
                  }
                }}
              />

              {/* To The Retailer */}
              <TextField
                name="retailer"
                type="text"
                label="To The Retailer"
                variant="outlined"
                fullWidth
                size="small"
                multiline
                rows={3}
                value={productData.retailer || ""}
                onChange={(e) => setProductData({ ...productData, retailer: e.target.value })}
                error={retailerError}
                helperText={retailerError && "Please add retailer instructions"}
                sx={{
                  mb: 1.5,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '20px',
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '0.7rem',
                  }
                }}
              />

              {/* To The Consumer */}
              <TextField
                name="consumer"
                type="text"
                label="To The Consumer"
                variant="outlined"
                fullWidth
                size="small"
                multiline
                rows={3}
                value={productData.consumer || ""}
                onChange={(e) => setProductData({ ...productData, consumer: e.target.value })}
                error={consumerError}
                helperText={consumerError && "Please add consumer terms"}
                sx={{
                  mb: 0,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '20px',
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: '0.7rem',
                  }
                }}
              />
          </Paper>

          {/* Preview Coupon Section */}
          <Paper elevation={0} sx={{ p: 0 }}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 600 }}>
              Preview Coupon
            </Typography>

              {/* Coupon Preview */}
              <Box sx={{
                bgcolor: '#e8e8e8',
                borderRadius: 3,
                p: 2.5,
                mb: 3,
                minHeight: 320,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {src ? (
                  <Box sx={{
                    bgcolor: 'white',
                    p: 2.5,
                    borderRadius: 2.5,
                    width: '100%',
                    border: '3px solid #1565c0'
                  }}>
                    {/* Coupon Header */}
                    <Box sx={{ bgcolor: '#1565c0', px: 1.5, py: 0.75, mb: 1.5, borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'white', display: 'block', textAlign: 'center', fontWeight: 500 }}>
                        Limit one Coupon per visit | Manufacturer's Coupon
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
                      {/* Product Image */}
                      {productImage.length > 0 && (
                        <Box sx={{ width: 90, height: 90, flexShrink: 0 }}>
                          <img
                            src={productImage[0]}
                            alt="product"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          />
                        </Box>
                      )}

                      {/* Coupon Details */}
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#1565c0', mb: 0.5 }}>
                          {productData.offerDesc || 'Save $1.00 Now'}
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, mb: 0.5 }}>
                          {productData.name || 'Product Name - 1Kg'}
                        </Typography>
                        <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#666', lineHeight: 1.3 }}>
                          {productData.shortDesc || 'Product description goes here'}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Barcode/QR Code */}
                    <Box sx={{ textAlign: 'center', my: 1.5, bgcolor: '#f9f9f9', py: 1, borderRadius: 1 }}>
                      <img src={src} alt="code" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Box>

                    {/* Consumer/Retailer text */}
                    <Typography variant="caption" sx={{ fontSize: '0.6rem', color: '#333', display: 'block', mb: 0.75, lineHeight: 1.4 }}>
                      <strong>TO THE CONSUMER:</strong> {productData.consumer || 'Do not double. Valid one per household...'}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.6rem', color: '#333', display: 'block', lineHeight: 1.4 }}>
                      <strong>TO THE RETAILER:</strong> {productData.retailer || 'Do not double. Void when reproduced, copied, transferred, etc.'}
                    </Typography>
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Coupon preview will appear here
                  </Typography>
                )}
              </Box>

            {/* Action Buttons - Grid layout */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<DownloadIcon />}
                  disabled={!src}
                  sx={{
                    borderRadius: '25px',
                    textTransform: 'none',
                    py: 1
                  }}
                  onClick={() => {
                    // Download functionality
                    const link = document.createElement('a');
                    link.href = src;
                    link.download = 'coupon.png';
                    link.click();
                  }}
                >
                  Download
                </Button>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<SendIcon />}
                  disabled={!src}
                  sx={{
                    borderRadius: '25px',
                    textTransform: 'none',
                    py: 1
                  }}
                >
                  Send
                </Button>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<PrintIcon />}
                  disabled={!src}
                  sx={{
                    borderRadius: '25px',
                    textTransform: 'none',
                    py: 1
                  }}
                  onClick={() => window.print()}
                >
                  Print
                </Button>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  disabled={!src}
                  sx={{
                    borderRadius: '25px',
                    textTransform: 'none',
                    py: 1
                  }}
                  onClick={() => {
                    setProductImage([]);
                    setUploadImage([]);
                    setProductData({});
                  }}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>

            {/* Save Coupon Button */}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              startIcon={<ConfirmationNumberIcon />}
              disabled={src === false || loading}
              sx={{
                borderRadius: '25px',
                textTransform: 'none',
                py: 1.2,
                bgcolor: '#1976d2',
                '&:hover': {
                  bgcolor: '#1565c0'
                }
              }}
            >
              {loading ? "Saving..." : "Save Coupon"}
            </Button>

            {/* Footer Links */}
            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Link href="#" underline="hover" sx={{ fontSize: '0.75rem', color: '#1976d2', mr: 2 }}>
                Privacy Policy
              </Link>
              <Link href="#" underline="hover" sx={{ fontSize: '0.75rem', color: '#1976d2' }}>
                Terms of Use
              </Link>
            </Box>
          </Paper>
        </Box>
      </Box>

      <SubscriptionModal
        show={showSubscriptionModal}
        onHide={handleHideSubscriptionModal}
      />
    </Box>
  );
};
